import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

export type FinanceSummaryCardProps = {
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  iconContainerClassName: string;
};

const useStyles = makeStyles()((theme) => ({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.common.white
  },
}));

export const FinanceSummaryCard: React.VFC<FinanceSummaryCardProps> = ({ label, value, icon, iconContainerClassName }) => {
  const { classes, cx } = useStyles();

  return (
    <Paper variant="outlined">
      <Box p={2} display="flex" gap="1rem" alignItems="center" pr={4}>
        <Box className={cx(classes.iconContainer, iconContainerClassName)}>
          {icon}
        </Box>
        <Box>
          <Typography>{value}</Typography>
          <Typography variant="body2">{label}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

